<div class="error" *ngIf="!this.chartService.showChart">
  {{ this.chartService.errorMessage }}
</div>

<apx-chart *ngIf="this.chartService.showChart && this.chartService.chartOptions"
  [series]="this.chartService.chartOptions.series" [chart]="this.chartService.chartOptions.chart"
  [xaxis]="this.chartService.chartOptions.xaxis" [title]="this.chartService.chartOptions.title">
</apx-chart>
